var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F45E20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50C11.2,50,0,38.8,0,25S11.2,0,25,0c13.8,0,25,11.2,25,25S38.8,50,25,50z M25,2C12.3,2,2,12.3,2,25 s10.3,23,23,23s23-10.3,23-23S37.7,2,25,2z M25,37.8c-5,0-9.5-2.8-11.7-7.3c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.3,0.6-0.5,0.9-0.5 c0.3,0,0.6,0.1,0.8,0.6c1.9,3.8,5.7,6.2,9.9,6.2c4.3,0,8.1-2.4,9.9-6.2c0.2-0.5,0.6-0.6,0.8-0.6c0.4,0,0.7,0.2,0.9,0.5 c0.2,0.3,0.2,0.6,0,0.9C34.5,35,30,37.8,25,37.8z M31.3,19.7c-1.2,0-2.3-1-2.3-2.3c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3 C33.5,18.7,32.5,19.7,31.3,19.7z M18.7,19.7c-1.2,0-2.3-1-2.3-2.3c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3 C21,18.7,20,19.7,18.7,19.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile1);
export default __webpack_public_path__ + "static/media/smile1.58654bb2b07013daf1f94022bf2054a7.svg";
export { ForwardRef as ReactComponent };